import { getDiscountAmount, priceToNumber } from '../price';
import { AFFILIATION_NAME_OPERATOR, getProductCategoriesTree } from './helpers';

import type { TypeGTMProduct } from '@/types';

export const normalizeCartItems = (data: any): any => {
  //TODO: coger el cupon anadido a cada producto
  //TODO: anadir productos También te puede interesar
  //TODO: anadir la marca del producto --to discuss with the team
  const cartItems: any[] = data?.contents?.edges;
  const items: Array<TypeGTMProduct> = [];

  if (cartItems) {
    cartItems.forEach((element, index) => {
      let product;

      const productVariation = element.node.variation;
      if (productVariation) {
        product = productVariation.node;
      } else {
        product = element.node.product.node;
      }

      const onSale = element.node.product.node.onSale;

      let discount;
      if (onSale) {
        discount = Number.parseFloat(
          getDiscountAmount(
            priceToNumber(product.regularPrice),
            priceToNumber(product.salePrice),
          ).toFixed(2),
        );
      }

      const brand =
        element.node.product.node.caracteriSticasDelProducto.datosDeProducto
          .marca;

      const seller =
        product.sellerInfo.name === 'Bigcrafters'
          ? AFFILIATION_NAME_OPERATOR
          : product.sellerInfo.name;

      const quantity = element.node.quantity;

      let item: TypeGTMProduct = {
        item_id: product.sku,
        item_name: product.name,
        affiliation: seller,
        currency: 'EUR',
        discount: onSale && discount ? discount * quantity : null,
        index,
        item_brand: Array.isArray(brand) ? brand[0]?.slug : null,
        item_list_id: null,
        item_list_name: null,
        item_variant: productVariation ? product.sku : null,
        price: priceToNumber(product.regularPrice) * quantity,
        quantity,
      };

      if (element.node.product.node.productCategories) {
        const categories = getProductCategoriesTree(element.node.product.node);

        item = {
          ...item,
          ...categories,
        };
      }

      items.push(item);
    });
  }

  return items;
};
